// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"21bdd448","703":"365e94cd"}[chunkId] + ".chunk.js";
};